import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("circle", {
        cx: "7",
        cy: "12",
        r: "7",
        fill: "#EA001B"
      }),
      _createElementVNode("circle", {
        cx: "17",
        cy: "12",
        r: "7",
        fill: "#FFA200",
        "fill-opacity": ".8"
      })
    ], -1)
  ])))
}
export default { render: render }